"use strict";

exports.__esModule = true;
exports.LogbookContext = void 0;
var _LogbookController = require("./LogbookController");
var _Utils = require("../../../Utils");
/**
 * Provides a logbook context to consumers
 * @component
 */
var LogbookContext = exports.LogbookContext = (0, _Utils.createEnhancedContext)({
  propName: "logbook",
  defaultController: _LogbookController.LogbookController
});